// removed by extract-text-webpack-plugin
module.exports = {"Burger":"Burger__Burger__3K4F-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/Burger.css
// module id = 106
// module chunks = 0